import o from"@razlet/ui/lib/modules/components/bottom-bar/index.js";var t={name:"widget-bottom-bar",extends:o,methods:{lockScroll:function(){}}};export{t as default};
